var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 310,
    viewBox: "0 0 300 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.4541 310H0L100 210H119.085L72.4541 310ZM200 310H83.4883L130.118 210H300L200 310ZM121.421 204.989L121.444 205H100L0 105H168.048L121.421 204.989ZM300 205H132.45L179.08 105H200L300 205ZM170.379 100H0L100 0H217.01L170.379 100ZM200 100H181.412L228.043 0H300L200 100Z",
    fill: "url(#paint0_linear_3_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_26",
    x1: -5.10006e-7,
    y1: 83.7806,
    x2: 300,
    y2: 223.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD83FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#671CA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5d82bdb7e6c101b4f29e87f705687ba1.svg";
export { ForwardRef as ReactComponent };